export interface SelectOption {
  text: string;
  value: string;
  imagePath?: string;
}

export enum RegistrationStep {
  termsAndConditions,
  personalDetails,
  registrationSuccess,
}
